import { render, staticRenderFns } from "./ManagerTab.vue?vue&type=template&id=96c3dcde&"
import script from "./ManagerTab.vue?vue&type=script&lang=js&"
export * from "./ManagerTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagerTab.vue?vue&type=style&index=0&id=96c3dcde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports